/* Local dependencies */
import { User } from '../../types';

export enum GetUserActionTypes {
  GET_USER_REQUEST = 'GET_USER_REQUEST',
  GET_USER_SUCCESS = 'GET_USER_SUCCESS',
  GET_USER_ERROR = 'GET_USER_ERROR',
}

export interface GetUser {
  type: GetUserActionTypes.GET_USER_REQUEST;
  userId: string;
}

export interface GetUserSuccess {
  type: GetUserActionTypes.GET_USER_SUCCESS;
  user: User;
}

export interface GetUserError {
  type: GetUserActionTypes.GET_USER_ERROR;
  error: Error;
}

export type GetUserAction = GetUser | GetUserSuccess | GetUserError;
